import React from 'react';
import { ClockIcon } from './Icons';
export const UrgencyBlock = () => {
  return <section className="w-full bg-white py-4 md:py-6 px-4 md:px-6" data-id="element-254">
      <div className="max-w-[700px] mx-auto bg-light border-[2px] border-accent rounded-[16px] p-6 md:p-8 flex flex-col items-center" data-id="element-255">
        <ClockIcon color="#957DAD" size={32} className="mb-4" data-id="element-256" />

        <h3 className="font-playfair text-[24px] md:text-[28px] text-primary text-center mb-4" data-id="element-257">
          Launch Pricing — While The Method Is New
        </h3>

        <div className="font-lato text-[16px] text-secondary text-center leading-relaxed" data-id="element-258">
          <p className="mb-4" data-id="element-259">
            The complete bundle is available at $27 during the early launch
            period. Once this initial phase closes, the price will gently move
            to $47.
          </p>
          <p className="m-0" data-id="element-260">
            No countdowns. No pressure. Just an honest reflection of what's
            ahead.
          </p>
        </div>
      </div>
    </section>;
};